const Menu =  [
  { header: 'Apps' },
  {
    title: 'Dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    dispatch:'fetchFriends'
  },

  { divider: true },
  { header: 'Community' },
  {
    title: 'Coupons',
    group: 'apps',
    icon: 'local_atm',
    name: 'widget-coupons',
    dispatch:'fetchCoupons'
  }
];

// reorder menu
Menu.forEach((item) => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu_merchants.js